import { module as m } from 'modujs';
import gsap from 'gsap';

export default class extends m {
    constructor(m) {
        super(m);
    }

    init() {}

    /**
     * SHOW
     */
    show() {
        this.el.classList.add('visible');
        const _tl = gsap.timeline();
        _tl.set(this.$('item'), {
           transformOrigin: '0 100%'
        });
        _tl.to(this.$('item'), {
            duration: 1.2,
            scaleY: 1,
            stagger: 0.02,
            ease: 'power4.inOut'
        });
    }

    /**
     * HIDE
     */
    hide() {
        console.log('HIDE PRELOAD');
        const _tl = gsap.timeline({
            onComplete: () => {
                this.el.classList.remove('visible');
            }
        });
        _tl.set(this.$('item'), {
            transformOrigin: '0 0'
        });
        _tl.to(this.$('item'), {
            duration: 1.2,
            scaleY: 0,
            stagger: 0.02,
            ease: 'power4.inOut'
        });
    }
}
